export default {"src":"/_next/static/media/no_dynamic_rewards.a1ab8d29.svg","height":150,"width":221};